import React from 'react';
import { useTranslation } from 'react-i18next';

import CountrySelect from './components/CountrySelect';
import DatesSelect from './components/DatesSelect';
import { 
  IInsurance,
  InsuranceParameters, 
  SetInsuranceParameters,
  SetInsurance 
} from '../../types';
import { useNavigate } from 'react-router-dom';
import TouristsSelect from './components/TouristsSelect';
import { Wrapper, AllInputsWrapper, AllInsurances } from './style';

let today = new Date();

let tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
tomorrow.toLocaleDateString();

type Props = {
  insurance: IInsurance;
  insuranceParameters?: InsuranceParameters;
  setInsuranceParameters?: SetInsuranceParameters;
  setInsurance: SetInsurance;
  withoutButton?: boolean; 
};

const Inputs: React.FC<Props> = ({
  insuranceParameters,
  insurance,
  setInsuranceParameters,
  setInsurance,
  withoutButton  
}) => {
  const { t } = useTranslation();  
  const { selectedCountry, selectedDates } =
    insuranceParameters;

  const countryIsSelected = !!selectedCountry.id || !!insurance.details.destination;
  const datesAreSelected = (!!selectedDates.endDate && !!selectedDates.startDate) 
    || (!!insurance.details.start_date && !!insurance.details.end_date);
  const touristsAreSelected = 
    insurance.beneficiary.length > 0 && 
    insurance.beneficiary.every(tourist => tourist.date_of_birth !== '');
  
  const allFieldsSelected =
    countryIsSelected && datesAreSelected && touristsAreSelected;

  const navigate = useNavigate();

  const handleNavigate = () => {   
    navigate('/offers', { state: insuranceParameters });
  }; 

  return (
    <Wrapper>
      <AllInputsWrapper>
        <CountrySelect
          insuranceParameters={insuranceParameters}
          setInsuranceParameters={setInsuranceParameters}
        />
        <DatesSelect
          insurance={insurance}        
          insuranceParameters={insuranceParameters}
          setInsuranceParameters={setInsuranceParameters}
          setInsurance={setInsurance}
        />
        <TouristsSelect
          insurance={insurance}
          setInsurance={setInsurance}
          insuranceParameters={insuranceParameters}
          setInsuranceParameters={setInsuranceParameters}        
        />
      </AllInputsWrapper>
      {!withoutButton && (
        <AllInsurances onClick={handleNavigate} disabled={!allFieldsSelected}>
          {t('all_insurance')}
        </AllInsurances>
      )}
    </Wrapper>
  );
};

export default Inputs;
